import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';

import useStyles from '../styles';

const ValidationResult = ({ data }) => {
  const { resultContainer, bold, green, red } = useStyles();

  return (
    <Box className={resultContainer}>
      <Box display="flex" alignItems="center" mb={data.message ? 2 : 0}>
        {data.isSuccess ? (
          <CheckCircleIcon className={green} style={{ marginRight: 8 }} />
        ) : (
          <ErrorIcon className={red} style={{ marginRight: 8 }} />
        )}
        <Typography variant="body1" component="span">
          Result:&nbsp;
        </Typography>
        <Typography variant="body1" component="span" className={bold}>
          {data.isSuccess ? (
            <span className={green}>Success</span>
          ) : (
            <span className={red}>Failed</span>
          )}
        </Typography>
      </Box>
      {data.message && (
        <Box pl={4}>
          <Typography variant="body2" color="textSecondary">
            {data.message}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

ValidationResult.propTypes = {
  data: PropTypes.shape({
    isSuccess: PropTypes.bool.isRequired,
    message: PropTypes.string,
  }),
};

export default ValidationResult;
